import type { Editor } from "@tiptap/core";

import { Button } from "@/components/ui/button/button";
import { BwMentionLine } from "@/components/ui/icons";

export function MentionButton({ editor }: { editor: Editor }) {
  const onMentionClick = () => {
    if (!editor) return;

    const { state } = editor;
    const { from, to } = state.selection;
    const textBeforeCursor = state.doc.textBetween(0, from, undefined, "\0");

    const consecutiveAtSymbols = countTrailingAtSymbols(textBeforeCursor);

    if (consecutiveAtSymbols > 0) {
      deleteExistingAtSymbols(consecutiveAtSymbols, from, to);
    }

    insertNewAtSymbol();
  };

  const countTrailingAtSymbols = (text: string): number => {
    let count = 0;
    for (let i = text.length - 1; i >= 0; i--) {
      if (text[i] !== "@") break;
      count++;
    }
    return count;
  };

  const deleteExistingAtSymbols = (count: number, from: number, to: number) => {
    if (!editor) return;
    editor
      .chain()
      .focus()
      .deleteRange({ from: from - count, to })
      .run();
  };

  const insertNewAtSymbol = () => {
    if (!editor) return;
    editor.chain().focus().insertContent("@").run();
  };
  return (
    <Button
      kind="ghost"
      variant="neutral"
      size="icon-md"
      type="button"
      data-test="mention-icon"
      onClick={onMentionClick}
    >
      <BwMentionLine size={20} />
    </Button>
  );
}
